var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{'mar_r_0':(_vm.index+1)%3==0},on:{"click":_vm.handleRouterSkip}},[_c('img',{attrs:{"src":_vm.item.Cover,"alt":""}}),_c('h2',[_vm._v(_vm._s(_vm.item.Title))]),_c('p',[_vm._v(_vm._s(_vm.item.Summary))])])}
var staticRenderFns = []

export { render, staticRenderFns }